module.exports = __webpack_public_path__ + "media/images/applicant/01-aba434c60a2dfe91b9539cb5600c37aa.png";